/**
 * @module Utilities/Location
 * @desc Location helper funtions
 */

import qs from 'qs';

import type { Utilities } from 'core/domains';

/**
 * Stringify location search
 *
 */
export function queryStringify(input: Utilities.PlainObject, options: Utilities.PlainObject = {}) {
  const settings = {
    arrayFormat: 'indices' as const,
    addQueryPrefix: false,
    encoder: (str: string) => encodeURI(str),
    encodeValuesOnly: true,
    ...options,
  };

  return qs.stringify(input, settings);
}
